'use client';
import { useRouter } from 'next/navigation';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { SiGoogledocs } from 'react-icons/si';

import { Button } from '@/slw/shared/ui/button';
import { AnimatedText } from '@/slw/shared/ui/animated-text';

export function DealerApplicationBanner() {
  const router = useRouter();
  const handleApply = () => {
    router.push('/become-dealer-partner');
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className='
      relative
      w-full
      max-w-full
      mx-auto
      h-auto
      py-10
      flex items-center justify-center
      rounded-[2rem]
      overflow-hidden
    '
    >
      {/* Ảnh nền với filter sepia và animation */}
      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        className='absolute inset-0 w-full h-full'
      >
        <Image
          src='/images/dealer-partner/dealer-banner-bg.png'
          alt='Dealer Application Banner'
          fill
          className='object-cover object-center filter sepia-[0.5] grayscale-[0.3]'
          priority
          quality={90}
          sizes='(max-width: 640px) 100vw, (max-width: 1024px) 80vw, 1360px'
        />
        {/* Overlay màu nâu */}
        <div className='absolute inset-0 z-10 bg-[#463928B2]' />
      </motion.div>
      {/* Content với animation */}
      <div className='relative z-20 flex flex-col items-end justify-between w-full h-full pr-12 py-8 xl:pr-28 lg:pr-20'>
        <AnimatedText
          text='More than 5 vehicles to sell?'
          className='text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl 
        xl:text-[4rem] font-bold text-center md:text-left flex-1'
        />
        <AnimatedText
          text='Be a dealer to get the top offers for Clovis Classics.'
          className='text-white uppercase text-[1rem] my-5.5 font-semibold text-center md:text-left flex-1'
        />
        <motion.div
          variants={{
            visible: { opacity: 1, y: 0 },
            hidden: { opacity: 0, y: 40 },
          }}
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.24 }}
        >
          <Button onClick={handleApply} variant='default' color='primary' className='font-bold gap-4'>
            Apply for our Dealership program
            <SiGoogledocs className='w-4 h-4' />
          </Button>
        </motion.div>
      </div>
    </motion.section>
  );
}
